// extracted by mini-css-extract-plugin
export default {"input":"styles_input__mAKkh","controls":"styles_controls__6J4cq"};